import { render } from "./index.vue?vue&type=template&id=0cdf3500&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=0cdf3500&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdf3500"]])

export default __exports__